import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Values from './components/Values';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ServiceCivil from './components/ServiceCivil';
import ServiceElectrical from './components/ServiceElectrical';
import ServiceBorehole from './components/ServiceBorehole';
import ServiceContracting from './components/ServiceContracting';
import ScrollToTop from './components/ScrollToTop';
import ScrollUpButton from './components/ScrollUpButton';

function HomePage() {
  return (
    <>
      <Hero />
      <StatsBar />
      <About />
      <Services />
      <Projects />
      <Values />
      <Contact />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/civil-construction" element={<ServiceCivil />} />
          <Route path="/services/electrical-mechanical" element={<ServiceElectrical />} />
          <Route path="/services/borehole-water" element={<ServiceBorehole />} />
          <Route path="/services/general-contracting" element={<ServiceContracting />} />
        </Routes>
      </main>
      <Footer />
      <ScrollUpButton />
    </BrowserRouter>
  );
}
